import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SignupComponent } from './signup.component';
import {AlertListModule, TranslateModule} from "@xref/ngx";
import { OmniLoaderModule } from "../../components/omni-loader/omni-loader.module";
import {ButtonModule, DropdownModule, InputsModule} from "@xref/xref-lib";
import {RequiredValidatorModule} from "../../components/required-validator/required-validator.module";
import {RouterModule} from "@angular/router";
import {EmailValidatorModule} from "../../components/email-validator/email-validator.module";
import { CountryPhoneCodesService } from '../../services/country-phone-codes/country-phone-codes.service';


@NgModule({
    declarations: [
        SignupComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        RequiredValidatorModule,
        RouterModule,
        EmailValidatorModule,
        TranslateModule,
        OmniLoaderModule,
        AlertListModule,
        InputsModule,
        DropdownModule,
        ButtonModule,
    ],
    providers: [
        CountryPhoneCodesService
    ]
})
export class SignupModule { }
